



















import { Component, Vue } from 'vue-property-decorator';
import { AccountApi } from '@/api/account-api';

const api = new AccountApi();

@Component
export default class ForgotPasswordForm extends Vue {
    public email: string | null = null;

    public get isValid(): boolean {
        return this.email != null && this.email.length > 0;
    }

    public async submit(): Promise<void> {
        if (!this.isValid) {
            return;
        }

        try {
            await api.forgotPasswordAsync(this.email!);
        } catch (e) {
            return;
        }

        this.$router.push({ name: 'login' });
    }
}
